import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ConfigService } from '../../config.service';

import { ButtonComponent } from './button.component';

import { RippleDirective } from './directives/ripple.directive';

export * from './button.enum';
export * from './button.interface';

export { ButtonComponent } from './button.component';

export { RippleDirective } from './directives/ripple.directive';

@NgModule({
  declarations: [
    ButtonComponent,

    RippleDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    ButtonComponent,

    RippleDirective
  ],
  schemas: [],
  providers: [
    ConfigService
  ]
})
export class ButtonModule { }
